import TablePagination from '@mui/material/TablePagination'

import { useEffect, useState, useCallback, useRef } from 'react'

import TablePaginationActions from '@/components/Table/Generic/BackofficeTablePagination/TablePaginationActions'

const TablePaginationDefault = ({ onPaginationChange, nextPageToken = '', initialRowsPerPage = 10 }) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage)
  const [pageTokens, setPageTokens] = useState([''])
  const previousTokenRef = useRef('')

  const submit = useCallback(
    (pageIndex, limit, nextToken) => {
      onPaginationChange({
        limit,
        nextPage: nextToken
      })
    },
    [onPaginationChange]
  )

  useEffect(() => {
    if (!nextPageToken || nextPageToken === previousTokenRef.current) return

    previousTokenRef.current = nextPageToken

    setPageTokens((prev) => {
      if (prev.includes(nextPageToken)) return prev
      return [...prev, nextPageToken]
    })
  }, [nextPageToken])

  const handlePageChange = (_, newPage) => {
    setPage(newPage)
    const tokenForPage = pageTokens[newPage] || ''
    submit(newPage, rowsPerPage, tokenForPage)
  }

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = Number.parseInt(event?.target?.value, 10)
    setPage(0)
    setRowsPerPage(newRowsPerPage)
    setPageTokens([''])
    submit(0, newRowsPerPage, '')
  }

  const labelDisplayedRows = ({ from, to }) => {
    const hasNextPage = Boolean(nextPageToken)
    const count = hasNextPage ? -1 : to
    const countDisplay = count === -1 ? `mais que ${to}` : count
    return `${from} - ${to} de ${countDisplay}`
  }

  const total = nextPageToken ? (page + 2) * rowsPerPage : (page + 1) * rowsPerPage

  return (
    <TablePagination
      ActionsComponent={TablePaginationActions}
      component="div"
      count={total}
      labelDisplayedRows={labelDisplayedRows}
      labelRowsPerPage={'Resultados por página:'}
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleRowsPerPageChange}
      page={page}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={[5, 10, 20, 50]}
    />
  )
}

export default TablePaginationDefault
